import apiCallsIcon from '~/assets/svg/audit/kpi-api-calls.svg';
import screensIcon from '~/assets/svg/audit/kpi-screens.svg';
import usersIcon from '~/assets/svg/audit/kpi-users.svg';
import visitsIcon from '~/assets/svg/audit/kpi-visits.svg';
import { AuditOverview } from '../models';
import * as St from '../styles';
import { formatDecimal, formatNumber } from '../utils';
import { CardStatusProps } from './CardStatus';

// Os quatro cards ficam sempre na tela; só o valor troca pelo loading.
const OverviewCards: React.FC<{ data?: AuditOverview } & CardStatusProps> = ({
  data,
  loading,
  error,
}) => {
  if (error) return <St.ErrorBox role="alert">{error}</St.ErrorBox>;

  const ready = !loading && data;
  const cards = [
    {
      title: 'Visita as telas',
      icon: visitsIcon,
      value: data?.visitas,
      hint: 'Uma visita por abertura de tela',
    },
    {
      title: 'Telas visitadas',
      icon: screensIcon,
      value: data?.telasVisitadas,
      hint: `De ${data?.totalTelas ?? '-'} telas do backoffice`,
    },
    {
      title: 'Chamadas de API',
      icon: apiCallsIcon,
      value: data?.chamadasApi,
      hint: `${formatDecimal(
        data?.chamadasPorVisita ?? null,
      )} chamadas por visita, em média`,
    },
    {
      title: 'Usuários',
      icon: usersIcon,
      value: data?.usuarios,
      hint: 'IDs distintos nas visitas selecionadas',
    },
  ];

  return (
    <div>
      <St.KpiGrid>
        {cards.map((card) => (
          <St.KpiCard key={card.title}>
            <header>
              <span>{card.title}</span>
              <img src={card.icon} alt="" />
            </header>
            {ready ? (
              <div>
                <strong>{formatNumber(card.value ?? 0)}</strong>
                <small>{card.hint}</small>
              </div>
            ) : (
              <St.Spinner role="status" aria-label="Carregando" />
            )}
          </St.KpiCard>
        ))}
      </St.KpiGrid>
      {ready && (
        <St.KpiFooter>
          <span>
            <b>{data.servicosApi}</b> serviços de API
          </span>
          <span>
            {formatNumber(data.visitasSemUsuario)} visitas sem usuário
          </span>
        </St.KpiFooter>
      )}
    </div>
  );
};

export default OverviewCards;
